/**
 * @returns object
 *  {
 *    elm // アニメーション対象のdom
 *    isShown // アニメーションしたかどうか
 *    top // ページ上部からアニメーション対象domまでの位置
 *    topStart // アニメーション開始位置
 *  }
 */
export function createAnimationobject(elm, variable = 1.0) {
  return {
    isShown: false,
    targetElm: elm,
    top : elm.getBoundingClientRect().top + window.pageYOffset,
    topStart : elm.getBoundingClientRect().top + window.pageYOffset - window.innerHeight * variable
  }
}

export function setSize({ object, property, variable = 1.0 }) {
  object.elm = document.querySelector(property)
  object.isShown = false
  const { top, topStart } = setScrollOption(object.elm, variable)
  object.top = top
  object.topStart = topStart
}

export function setMultiSize({ array, property, variable = 1.0 }) {
  Array.prototype.forEach.call(
    document.querySelectorAll(property),
    (el) => {
      const object = { isShown: false }
      object.elm = el

      const { top, topStart } = setScrollOption(object.elm, variable)
      object.top = top
      object.topStart = topStart

      array.push(object)
    }
  )
}

// setting
export function setScrollOption(elm, variable) {
  return {
    top : elm.getBoundingClientRect().top + window.pageYOffset,
    topStart : elm.getBoundingClientRect().top + window.pageYOffset - window.innerHeight * variable
  }
}

/**
 * @returns object
 *  {
 *    splitText // SplitTextにかけたコンストラクタ
 *    stTl // 初期位置を設定したSplitTextの情報が入っているTimelineMax
 *  }
 */
export function prepareSpliteText(elm, setOption = { opacity: 0 }) {
  const object = {}
  object.splitText = new SplitText(elm, {type:"chars, words"})
  object.stTl = new TimelineMax();

  for(var i = 0; i < object.splitText.chars.length ; i++){
    object.stTl.set(object.splitText.chars[i], setOption);
  }

  return object
}
